// getMeBalance.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

/**
 * Select user balance by me
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {number} The user balance.
 */
const getMeBalance = createSelector(
  state => state.getIn(['me', 'balance', 'total']) || 0,
  balance => balance
);

export default getMeBalance;
